module.exports = __webpack_public_path__ + "img/15-oneImg.034b10e7.png";